import React from 'react';

import CSSModules from 'react-css-modules';

import {TickBoxContent} from './TickBoxContent';

import styles from './styles.module.scss';

export type TickBoxProps = {
  checked: boolean;
  isPreviewMode?: boolean;
  altText: string;
  index?: number;
};

const TickBox = ({checked, isPreviewMode, ...rest}: TickBoxProps) => (
  <div
    data-automation={checked ? 'tick-icon-complete' : 'tick-icon-incomplete'}
    styleName={`${checked ? 'tickBoxCompleted' : 'tickBox'} ${
      isPreviewMode ? '' : 'no-preview'
    }`}
  >
    <TickBoxContent checked={checked} isPreviewMode={isPreviewMode} {...rest} />
  </div>
);

export default CSSModules(TickBox, styles, {allowMultiple: true});
